<template>
  <div :class="rootClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  noGutters?: boolean
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch'
  justify?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly'
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  /** CSS grid row. Skips PrimeFlex `.flex` (`display:flex !important`) so v-show can hide it. */
  subgrid?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  noGutters: false,
  align: 'start',
  justify: 'start',
  direction: 'row',
  subgrid: false,
})

const rowClasses = computed(() => ({
  'gap-0': props.noGutters,
  'gap-2': !props.noGutters,
  [`align-items-${props.align}`]: true,
  [`justify-content-${props.justify}`]: true,
  [`flex-${props.direction}`]: true,
}))

const rootClasses = computed(() => [
  props.subgrid ? 'm-row--subgrid' : 'flex flex-wrap',
  rowClasses.value,
])
</script>

<style scoped></style>
